import type { Component } from 'svelte';
import IconCalendarStar from '~icons/mdi/calendar-star';
import IconCoffeeOutline from '~icons/mdi/coffee-outline';
import IconWeatherNight from '~icons/mdi/weather-night';
import IconWeatherSunny from '~icons/mdi/weather-sunny';
import IconWeatherSunset from '~icons/mdi/weather-sunset';

export enum CityHighlightBestTime {
    MORNING = 'MORNING',
    AFTERNOON = 'AFTERNOON',
    EVENING = 'EVENING',
    NIGHT = 'NIGHT',
    SEASONAL = 'SEASONAL'
}

export interface CityHighlightBestTimeMeta {
    label: string;
    Icon: Component;
    textColour: string;
    bgColour: string;
}

export const CITY_HIGHLIGHT_BEST_TIME_METAS: Record<CityHighlightBestTime, CityHighlightBestTimeMeta> = {
    [CityHighlightBestTime.MORNING]: {
        label: 'Morning Highlights',
        Icon: IconCoffeeOutline,
        textColour: 'text-tod-morning',
        bgColour: 'bg-tod-morning'
    },
    [CityHighlightBestTime.AFTERNOON]: {
        label: 'Afternoon Exploration',
        Icon: IconWeatherSunny,
        textColour: 'text-tod-afternoon',
        bgColour: 'bg-tod-afternoon'
    },
    [CityHighlightBestTime.EVENING]: {
        label: 'Evening Magic',
        Icon: IconWeatherSunset,
        textColour: 'text-tod-evening',
        bgColour: 'bg-tod-evening'
    },
    [CityHighlightBestTime.NIGHT]: {
        label: 'Nightlife & Late Hours',
        Icon: IconWeatherNight,
        textColour: 'text-tod-night',
        bgColour: 'bg-tod-night'
    },
    [CityHighlightBestTime.SEASONAL]: {
        label: 'Seasonal Exclusives',
        Icon: IconCalendarStar,
        textColour: 'text-tod-seasonal',
        bgColour: 'bg-tod-seasonal'
    }
};